export const includeKeyWord = (dataStr: string, keyWords: string[]) => {
  let resultStr = dataStr

  // 遍历关键字数组，将每个关键字都用em标签替换
  keyWords.forEach((keyWord) => {
    const regExpKeyWord = new RegExp(keyWord, 'g')
    resultStr = resultStr.replace(
      regExpKeyWord,
      `<em style="font-style: normal; color: #AC1E1E; font-weight: 700; background-color: #FDE3BC;">${keyWord}</em>`,
    )
  })

  // 将\n替换为 <br />
  const regExpNewLine = /\n/g
  resultStr = resultStr.replace(regExpNewLine, '<br />')

  return resultStr
}
